import React from 'react';
import './ommig.css';

function Ommig () {
    return (
<div className='ommig-container'>
    <div className='top-left'>
        <h5>Hej! Jeg hedder Jakob Komischke-Konnerup, jeg elsker at skabe, designe og programmere løsningerne til den digitale virkelighed.</h5>
    </div>
    <div className='bottom-right'>
        <div className='ommig-border'>
            <p className='ommig-border-text'>Jeg studerer på Multimediedesigner Erhvervs Akademi Aarhus. I min fritid arbejder jeg som Foredragsafvikler ved FOF Aarhus, og er frivillig ved Nabolitteratur. Derudover elsker jeg at løbe, spille golf og at skrive! Derfor går jeg også på Talentskolens forfatterlinje i Næstved, hvor jeg arbejder med tekst og kommunikation.</p>
        </div>
    </div>
</div>
    )
}

export default Ommig;